import Dinero from 'dinero.js';

export const cleanValue = (value: string) => value.replace(/[^\d.]/g, '');

export const serializeAmount = (value: string) => {
  const valueInt = Math.trunc(parseFloat(cleanValue(value)) * 100);
  if (isNaN(valueInt)) {
    return Dinero({ amount: 0, precision: 2 });
  }
  return Dinero({ amount: valueInt, precision: 2 });
};

export const formatExchangeRate = (
  exchangeRate: number,
  destCurrency: string
) => {
  const money = Dinero({
    amount: Math.trunc((1 / exchangeRate) * 100),
    precision: 2,
  });

  return `${money.toFormat()} / ${destCurrency}`;
};

export const formatWithdrawAmount = (value: number, destCurrency: string) => {
  if (destCurrency === 'USD') {
    return serializeAmount(`${value}`).toFormat();
  }
  return `${value} ${destCurrency}`;
};
